"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadCrumbs = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var BreadCrumb_1 = require("./BreadCrumb");
;
var BreadCrumbs = function (_a) {
    var _b;
    var _c = _a.crumbs, crumbs = _c === void 0 ? [] : _c, _d = _a.routing, routing = _d === void 0 ? false : _d, _e = _a.customClasses, customClasses = _e === void 0 ? "" : _e;
    if (routing) {
        var location_1 = react_router_dom_1.useLocation();
        var url_1 = (_b = location_1 === null || location_1 === void 0 ? void 0 : location_1.pathname) === null || _b === void 0 ? void 0 : _b.split("/");
        crumbs = [];
        url_1 === null || url_1 === void 0 ? void 0 : url_1.shift();
        url_1 === null || url_1 === void 0 ? void 0 : url_1.forEach(function (el, index) {
            crumbs.push({ title: el, url: url_1.slice(0, index + 1).join("/") });
        });
    }
    return (react_1.default.createElement("div", { className: "axxes-header__title " + customClasses }, crumbs === null || crumbs === void 0 ? void 0 : crumbs.map(function (crumb, index, array) {
        return (react_1.default.createElement(react_1.default.Fragment, { key: index },
            react_1.default.createElement(BreadCrumb_1.BreadCrumb, { crumb: crumb, routing: location !== undefined }),
            index !== array.length - 1 && (react_1.default.createElement("span", { className: "axxes-header__title__divider" },
                react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 89.45 116.12" },
                    react_1.default.createElement("defs", null),
                    react_1.default.createElement("title", null, "Asset 1axxes-bullet"),
                    react_1.default.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
                        react_1.default.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                            react_1.default.createElement("polygon", { className: "cls-1", points: "80.7 0 49.73 49.25 20.48 0 0 0 39.15 66.08 30.72 79.2 33.62 84.36 42 71.01 68.83 116.12 89.45 116.12 52.73 54.18 86.89 0 80.7 0" }))))))));
    })));
};
exports.BreadCrumbs = BreadCrumbs;
